import Geofence from "./Geofence"

export default  Geofence;


// WEBPACK FOOTER //
// ./src/components/App/Geofence/index.js